import { render, staticRenderFns } from "./UserFamilyChildren.vue?vue&type=template&id=41942c67&scoped=true&"
import script from "./UserFamilyChildren.vue?vue&type=script&lang=js&"
export * from "./UserFamilyChildren.vue?vue&type=script&lang=js&"
import style0 from "./UserFamilyChildren.vue?vue&type=style&index=0&id=41942c67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41942c67",
  null
  
)

export default component.exports